export default __webpack_public_path__ + "96e67164eb6829ab9482995e69cb5f2a.png";